import { authAxios } from "../config";
import { ApiKey } from "../endpoints";

//get master technologies
export const GetMasterTechnologies = async () => {
  try {
    const res = await authAxios.get(`${ApiKey.GetMasterTech}`);
    return res.data;
  } catch (err) {
    return err;
  }
};
export const Logout = async () => {
  try {
    const res = await authAxios.get(`${ApiKey.logout}`);
    return res.data;
  } catch (err) {
    return err;
  }
};

//insert admin blogs
export const postBlogs = async (finalData) => {
  try {
    const res = await authAxios.post(`${ApiKey.postBlog}`, finalData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

// GetAdminsBlogs
export const GetAdminsBlogs = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.GetAdminBlogs}`, reqData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

export const GetBlog = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.GetBlog}`, reqData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

export const DeleteBlog = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.DeleteBlog}`, reqData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

export const changeBlogVisisbility = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.changeVisibility}`, reqData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};

export const UpdateYourBlog = async (reqData) => {
  try {
    const res = await authAxios.put(`${ApiKey.UpdateBlog}`, reqData);
    return res.data;
  } catch (err) {
    let error = err.response.data;
    console.error(error);
    return error;
  }
};
